import { ResourceCard } from './resource-card';
import type { CardProps } from './types';

/** Text block tile. */
export const TextCard = ({ block, onClick }: CardProps) => (
  <ResourceCard
    block={block}
    onClick={onClick}
    caption={block.title || 'Text Document'}
    bannerUrl={block.textBannerUrl}
  />
);
